<template>
    <div>
        <a-card type="inner" size="small">
            <a-table
                :columns="columns"
                :dataSource="items.attendants"
                rowKey="hash"
                :loading="loading"
                :pagination="false">

                <div slot="att_branch" slot-scope="record">
                    <strong>{{ record.name }}</strong><br/>
                    {{ record.members[0].branch.name }}
                </div>

                <div slot="npp" slot-scope="record">
                    
                </div>

                <div slot="notulen" slot-scope="record">
                    <a-button size="small" block @click="notulen(record.hash)">
                        VIEW
                    </a-button>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'att_branch',
            title: 'Outline',
            scopedSlots: {customRender: 'att_branch'},
        }, {
            key: 'npp',
            title: 'NPP',
            scopedSlots: {customRender: 'npp'}
        }, {
            key: 'notulen',
            title: 'Notulen',
            scopedSlots: {customRender: 'notulen'}
        }
    ]

    export default {
        props: {
            outline: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                columns,
                items: {
                    attendants: [],
                },
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        methods: {
            getItems() {
                this.loading = true;

                let params = this.activeModule.module.identifier == 'paper' ? null : {
                    params: {
                        outline: this.outline
                    }
                }

                this.$http
                    .get(this.routeUri("api.activity-notulens.attendants"), params)
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            notulen(hash){
                let params = {
                    user: hash,
                    previous: this.getRoute()
                }

                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.form') + '?' + this.$qs.stringify(params)
            }
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            }
        }
    }
</script>